import { Table } from "antd";

const Table100 = () => {
    const dataSource = [
        {
            key: 1,
            stt: 'Nhóm 1',
            industry: 'Bệnh viện (Tham gia chương trình Bệnh viện Công của Visa)',
            domesticBidv: '0.64%',
            domesticOther: '0.77%',
            visaBidv: '0.90%',
            visaOther: '1.01%',
            visaForeign: '3.33%',
            masterBidv: '0.90%',
            masterOther: '2.67%',
            masterForeign: '3.19%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 2,
            stt: 'Nhóm 2',
            industry: 'Bệnh viện (Không tham gia Chương trình BV công)',
            domesticBidv: '0.64%',
            domesticOther: '0.77%',
            visaBidv: '0.90%',
            visaOther: '2.34%',
            visaForeign: '3.27%',
            masterBidv: '0.90%',
            masterOther: '2.73%',
            masterForeign: '3.26%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 3,
            stt: 'Nhóm 3',
            industry: 'Siêu thị',
            domesticBidv: '0.64%',
            domesticOther: '0.77%',
            visaBidv: '1.25%',
            visaOther: '1.28%',
            visaForeign: '3.67%',
            masterBidv: '1.20%',
            masterOther: '1.67%',
            masterForeign: '3.67%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 4,
            stt: 'Nhóm 4',
            industry: 'Nhà hàng Đồ ăn Nhanh',
            domesticBidv: '0.64%',
            domesticOther: '0.77%',
            visaBidv: '1.20%',
            visaOther: '1.26%',
            visaForeign: '3.53%',
            masterBidv: '1.20%',
            masterOther: '1.39%',
            masterForeign: '3.52%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 5,
            stt: 'Nhóm 5',
            industry: 'Cửa hàng Điện tử',
            domesticBidv: '0.64%',
            domesticOther: '0.77%',
            visaBidv: '1.20%',
            visaOther: '1.66%',
            visaForeign: '3.28%',
            masterBidv: '1.20%',
            masterOther: '2.63%',
            masterForeign: '3.22%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 6,
            stt: 'Nhóm 6',
            industry: 'Dịch vụ Bảo hiểm',
            domesticBidv: '0.64%',
            domesticOther: '0.77%',
            visaBidv: '1.20%',
            visaOther: '1.22%',
            visaForeign: '3.00%',
            masterBidv: '1.20%',
            masterOther: '2.79%',
            masterForeign: '3.33%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 7,
            stt: 'Nhóm 7',
            industry: 'Quản lý và Đại lý Cho thuê Bất động sản',
            domesticBidv: '0.64%',
            domesticOther: '0.77%',
            visaBidv: '1.20%',
            visaOther: '1.17%',
            visaForeign: '3.50%',
            masterBidv: '1.20%',
            masterOther: '2.79%',
            masterForeign: '3.03%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 8,
            stt: 'Nhóm 8',
            industry: 'Taxi & Limousine',
            domesticBidv: '0.64%',
            domesticOther: '0.77%',
            visaBidv: '1.31%',
            visaOther: '1.31%',
            visaForeign: '4.40%',
            masterBidv: '1.31%',
            masterOther: '1.31%',
            masterForeign: '4.40%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 9,
            stt: 'Nhóm 9',
            industry: 'Cây xăng',
            domesticBidv: '0.64%',
            domesticOther: '0.77%',
            visaBidv: '1.20%',
            visaOther: '1.20%',
            visaForeign: '3.43%',
            masterBidv: '1.20%',
            masterOther: '1.20%',
            masterForeign: '3.41%',
            cup: '2.3%',
            jcb: '2.3%',
        },
    ];

    const columns = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            width: 55,
            align: 'center',
        },
        {
            title: 'Các ngành nghề',
            dataIndex: 'industry',
            key: 'industry',
            width: 200,
        },

        // THẺ NỘI ĐỊA
        {
            title: 'Thẻ nội địa',
            children: [
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            BIDV
                        </>
                    ),
                    dataIndex: 'domesticBidv',
                    key: 'domesticBidv',
                    width: 55,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Thẻ NH
                            <br />
                            khác
                        </>
                    ),
                    dataIndex: 'domesticOther',
                    key: 'domesticOther',
                    width: 55,
                    align: 'center',
                },
            ],
        },

        // THẺ VISA
        {
            title: 'Thẻ Visa',
            children: [
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            BIDV
                        </>
                    ),
                    dataIndex: 'visaBidv',
                    key: 'visaBidv',
                    width: 55,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Thẻ NH
                            <br />
                            khác
                        </>
                    ),
                    dataIndex: 'visaOther',
                    key: 'visaOther',
                    width: 55,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Thẻ Nước
                            <br />
                            ngoài
                        </>
                    ),
                    dataIndex: 'visaForeign',
                    key: 'visaForeign',
                    width: 60,
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
            ],
        },

        // THẺ MASTER
        {
            title: 'Thẻ Master',
            children: [
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            BIDV
                        </>
                    ),
                    dataIndex: 'masterBidv',
                    key: 'masterBidv',
                    width: 55,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Thẻ NH
                            <br />
                            khác
                        </>
                    ),
                    dataIndex: 'masterOther',
                    key: 'masterOther',
                    width: 55,
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Thẻ Nước
                            <br />
                            ngoài
                        </>
                    ),
                    dataIndex: 'masterForeign',
                    key: 'masterForeign',
                    width: 60,
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
            ],
        },

        // CUP
        {
            title: (
                <>
                    Thẻ
                    <br />
                    CUP
                </>
            ),
            dataIndex: 'cup',
            key: 'cup',
            width: 55,
            align: 'center',
            render: (value) => (
                <span className="text-danger">{value}</span>
            ),
        },

        // JCB
        {
            title: (
                <>
                    Thẻ
                    <br />
                    JCB
                </>
            ),
            dataIndex: 'jcb',
            key: 'jcb',
            width: 55,
            align: 'center',
            render: (value) => (
                <span className="text-danger">{value}</span>
            ),
        },
    ];
    return (
        <div className="mt-5">
            <h2 className="fw-bold fs-5 mb-3">GIÁ PHÍ ĐỐI VỚI BIG MERCHANT (NẾU ĐẠT MỨC DOANH SỐ 100 TỶ)</h2>
            <div>
                <Table
                    bordered
                    pagination={false}
                    dataSource={dataSource}
                    columns={columns}
                    rowKey="key"
                />
            </div>
        </div>

    );
};
export default Table100;